import service from "@/store/services/bid-steps-service";

export const state = () => ({
  list: {},
  bidStep: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, bidStep) => {
    state.bidStep = bidStep;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((bidStep) => {
      commit("SET_RESOURCE", bidStep);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((bidStep) => {
      commit("SET_RESOURCE", bidStep);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((bidStep) => {
      commit("SET_RESOURCE", bidStep);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  bidStep: (state) => state.bidStep,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((bidStep) => ({
      id: bidStep.id,
    }));
  },
};

const bidSteps = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default bidSteps;
